import type { ModelLinkProps } from "./model-link.type";

import { ExportOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";

import { getModelLink } from "@/modules/model";
import ModelIcon from "@/modules/model-icon";

import "./model-link.style.less";

export const ModelLink = ({
  model,
  item,
  showIcon,
  customModel,
  modelAsName,
  onClick,
  linkProps,
  searchParams,
}: ModelLinkProps) => {
  const { t } = useTranslation();
  const link = getModelLink(model, item);

  if (!link || !item) return undefined;

  const displayedModel = customModel ?? model;

  return (
    <div className="model-link">
      {showIcon === true && <ModelIcon model={displayedModel} />}
      <Link
        {...linkProps}
        to={{ pathname: link, search: searchParams }}
        onClick={onClick}
      >
        {modelAsName ? t(`global:modelLink.${displayedModel}`) : item.name}
      </Link>
      {showIcon === "external" && <ExportOutlined />}
    </div>
  );
};
